var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"pulse w-12 h-12 rounded-full bg-primary-orange text-white inline-flex items-center justify-center",on:{"click":_vm.click}},[_c('icon-arrow-down',{staticClass:"w-7 h-7 text-white"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }